"use client";

import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../../asset/logo.svg";
import { UserAuth } from "../../context/authContext";

export default function NavBar() {
  const [isOpen, setIsOpen]=useState(false);
  const { user, logout }=UserAuth();
  const navigate=useNavigate();
  const location=useLocation();

  const scrollToSection=(id) => {
    if (location.pathname==="/") {
      const el=document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      } else {
        window.location.hash=id;
      }
      return;
    }
    navigate(`/#${id}`);
    setTimeout(() => {
      const el=document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 250);
  };

  const handleLogout=async () => {
    try {
      await logout();
      window.location.href="/";
    } catch (error) {
      console.error(error.message);
    }
  };

  const handleLogin=() => {
    window.location.href="/login";
  };

  return (
    <header className="fixed top-0 w-full z-50 bg-gradient-to-b from-[#4916CF]/20 to-transparent">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <button onClick={() => navigate("/")}>
          <img
            src={logo}
            alt="AstraMiner logo"
            className="text-2xl text-white w-20 h-1w-20"
          />
        </button>

        <nav className="hidden md:flex gap-8 bg-gradient-to-r from-[#38149A] to-[#130734] rounded-full p-6 ">
          <button
            type="button"
            onClick={() => navigate("/")}
            className="text-white/80 hover:text-white text-sm bg-transparent p-0"
          >
            Home
          </button>
          <button
            type="button"
            onClick={() => scrollToSection("about")}
            className="text-white/80 hover:text-white text-sm bg-transparent p-0"
          >
            About
          </button>
          <button
            type="button"
            onClick={() => scrollToSection("features")}
            className="text-white/80 hover:text-white text-sm bg-transparent p-0"
          >
            Features
          </button>
          {user&&user.email&&(
            <button
              onClick={() => navigate("/dashboard")}
              className="text-white/80 hover:text-white text-sm"
            >
              Dashboard
            </button>
          )}

          <button
            type="button"
            onClick={() => scrollToSection("contact")}
            className="text-white/80 hover:text-white text-sm bg-transparent p-0"
          >
            Contact
          </button>
        </nav>

        {!user||!user?.email? (
          <button
            onClick={handleLogin}
            className="hidden md:block px-6 py-2 bg-[#4916CF] text-white rounded-full text-sm font-medium hover:bg-[#3a0fa8] transition-colors"
          >
            Login
          </button>
        ):(
          <button
            onClick={handleLogout}
            className="hidden md:block px-6 py-2 bg-red-600 text-white rounded-full text-sm font-medium hover:bg-red-700 transition-colors"
          >
            Logout
          </button>
        )}

        <button
          onClick={() => setIsOpen(!isOpen)}
          className="md:hidden text-white"
        >
          ☰
        </button>
      </div>

      {isOpen&&(
        <div className="md:hidden bg-[#1a0033] p-4 space-y-4">
          <button
            type="button"
            onClick={() => {
              setIsOpen(false);
              navigate("/");
            }}
            className="block text-white/80 text-sm bg-transparent p-0"
          >
            Home
          </button>
          <button
            type="button"
            onClick={() => {
              setIsOpen(false);
              scrollToSection("about");
            }}
            className="block text-white/80 text-sm bg-transparent p-0"
          >
            About
          </button>
          <button
            type="button"
            onClick={() => {
              setIsOpen(false);
              scrollToSection("features");
            }}
            className="block text-white/80 text-sm bg-transparent p-0"
          >
            Features
          </button>
          {user&&user.email&&(
            <button
              onClick={() => navigate("/dashboard")}
              className="block text-white/80 text-sm"
            >
              Dashboard
            </button>
          )}

          <button
            type="button"
            onClick={() => {
              setIsOpen(false);
              scrollToSection("contact");
            }}
            className="block text-white/80 text-sm bg-transparent p-0"
          >
            Contact
          </button>
          {!user||!user?.email? (
            <button
              onClick={handleLogin}
              className="w-full px-6 py-2 bg-[#4916CF] text-white rounded-full text-sm font-medium hover:bg-[#3a0fa8] transition-colors"
            >
              Login
            </button>
          ):(
            <button
              onClick={handleLogout}
              className="w-full px-6 py-2 bg-red-600 text-white rounded-full text-sm font-medium hover:bg-red-700 transition-colors"
            >
              Logout
            </button>
          )}
        </div>
      )}
    </header>
  );
}
